var React = require('react');

function RriFailed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 4v2H0V4h12zm0-4v2H0V0h12zM0 10V8h8v2H0zm19.633-.661l-3.184 3.184 3.184 3.184-1.41 1.41-3.184-3.184-3.184 3.184-1.41-1.41 3.184-3.184-3.184-3.184 1.41-1.41 3.184 3.184 3.184-3.184 1.41 1.41z","fill":"currentColor","fillRule":"evenodd"}));
}

RriFailed.defaultProps = {"width":"21","height":"18","viewBox":"0 0 21 18"};

module.exports = RriFailed;

RriFailed.default = RriFailed;
